angular.module('core')
    .component('varDebug', {
        bindings: {
            var: '<'
        },
        template: '<div ng-show="$ctrl.isDev"><pre>{{$ctrl.var | json}}</pre></div>',
        controller: function (ENV) {
            this.$onInit = () => {
                this.isDev = (ENV === "dev");
            }
        }
    })
